<template>
    <div class="canvas-combined-activities">

        <div class="head">
            <h5 class="mb-2">{{ section.name }}</h5>
            <p>{{ section.description }}</p>
        </div>

        <div class="podcasts" v-if="elements.filter(element => element.element?.data?.type === 'podcast').length > 0">
            <h5 class="mb-2">Podcasts</h5>
            <div class="podcast mb-4" v-for="element in elements.filter(element => element.element?.data?.type === 'podcast')">
                <InLinePodcast
                    :path="pathRepo"
                    :canvas="canvasRepo"
                    :stage="stage"
                    :section="section"
                    :editable="true"
                    :element="element"/>
            </div>
        </div>

        <h5 class="mb-2">Activities & Resources</h5>
        <div class="activities mb-3">
            <div v-for="(element, index) in elements.filter(element => element.element?.data?.type !== 'podcast')"
                 :key="element.id"
                 :class="`aw-${ elementWidth( element.element ) }  item-type-${element.element.type}`"
                 class="item">
                <div class="number" v-if="element.element.type !== 'add-new'">{{ index + 1 }}</div>

                <template v-if="element.element.type === 'resource'">

                    <!-- <canvas-podcast v-if="element.element?.data?.type === 'podcast'"
                                    :path="pathRepo"
                                    :canvas="canvasRepo"
                                    :stage="stage"
                                    :section="section"
                                    :editable="true"
                                    :headless="true"
                                    :hideSidebar="true"
                                    :element="element"/> -->

<!--                    <podcast v-if="element.element?.data?.type === 'podcast'"-->
<!--                             :path="pathRepo"-->
<!--                             :stage="stage"-->
<!--                             :section="section"-->
<!--                             :editable="false"-->
<!--                             :element="element"/>-->

                    <canvas-resource
                                     :resource="element.element"
                                     :in-path="elementInPath( element.element.id )"
                                     :in-canvas="elementInCanvas( element.element.id )"/>

                </template>

                <canvas-activity v-else-if="element.element.type === 'activity'"
                                 :stage="stage"
                                 :section="section"
                                 :canvas="canvasRepo"
                                 :fragment-prefix="section.id"
                                 :element="element"
                                 :in-path="elementInPath( element.element.id )"
                                 :in-canvas="elementInCanvas( element.element.id )"
                                 @upload="activityUploaded"
                                 @remove-canvas-element="removeCanvasElement( index )"/>
                <add-new-canvas-element v-else-if="element.element.type === 'add-new'"
                                        :stage="stage"
                                        @add-element="addElement($event)"/>
                </div>
        </div>

        <canvas-uploads
            class="mb-4"
            :path="pathRepo"
            :canvas="canvasRepo"
            :stage="stage"
            :section="section"
            :activities="activities"
            @uploads-changed="$emit('uploads-changed', $event)"/>


<!--        <draggable class="activities mb-3"-->
<!--                   v-model="elements"-->
<!--                   item-key="id"-->
<!--                   @change="changed"-->
<!--                   :group="`activity-section-${section.id}`">-->
<!--            <template #item="{element, index}">-->
<!--                <div :class="`aw-${ elementWidth( element.element ) }`"-->
<!--                     class="item">-->
<!--                    <div class="number" v-if="element.element.type !== 'add-new'">{{ index + 1 }}</div>-->
<!--                    <canvas-resource v-if="element.element.type === 'resource'"-->
<!--                                     :resource="element.element"-->
<!--                                     :in-path="elementInPath( element.element.id )"-->
<!--                                     :in-canvas="elementInCanvas( element.element.id )"/>-->
<!--                    <canvas-activity v-else-if="element.element.type === 'activity'"-->
<!--                                     :canvas="canvasRepo"-->
<!--                                     :fragment-prefix="section.id"-->
<!--                                     :element="element"-->
<!--                                     :in-path="elementInPath( element.element.id )"-->
<!--                                     :in-canvas="elementInCanvas( element.element.id )"-->
<!--                                     @upload="activityUploaded"-->
<!--                                     @remove-canvas-element="removeCanvasElement( index )"/>-->
<!--                    <add-new-canvas-element v-else-if="element.element.type === 'add-new'"-->
<!--                                            :stage="stage"-->
<!--                                            @add-element="addElement($event)"/>-->
<!--                </div>-->
<!--            </template>-->
<!--        </draggable>-->

<!--        <button class="btn btn-block btn-light border d-flex align-items-center">-->
<!--            <span class="label d-flex align-items-center text-muted">-->
<!--                <img src="/images/icons/eye-slash.svg" class="mr-1" alt="">-->
<!--                Hidden Activities (3)-->
<!--            </span>-->
<!--            <img class="ml-auto" style="width: 16px;" src="/images/icons/angle-right.svg" alt="">-->
<!--        </button>-->
    </div>
</template>

<script>
import draggable from "vuedraggable";
import CanvasActivity from "@/Components/Canvas/CanvasActivity";
import CanvasResource from "@/Components/Canvas/CanvasResource";
import AddNewCanvasElement from "@/Components/Canvas/AddNewCanvasElement";
import API from "@/API";
import {mapActions} from "vuex";
import utils from "@/mixins/utils";
import CanvasUploads from "@/Components/Canvas/CanvasUploads";
import Podcast from "@/Components/LearningPath/Podcast";
import CanvasPodcast from "@/Components/Canvas/CanvasPodcast";
import InLinePodcast from "@/Components/Podcast/InLinePodcast";

export default {
    name: "CanvasCombinedActivities",
    components: {CanvasPodcast, InLinePodcast, Podcast, CanvasUploads, CanvasResource, CanvasActivity, AddNewCanvasElement, draggable},
    props: ['pathRepo', 'canvasRepo', 'stage', 'section'],
    emits: ['update', 'uploads-changed'],
    mixins: [utils],

    data(){
        return {
            is_busy: false,
            elements: [],
        }
    },

    computed: {

        _$$path(){
            return this.pathRepo.fragments;
        },
        _$$canvas(){
            return this.canvasRepo?.fragments;
        },

        fragment_key(){
            return `stage_${this.stage}_combined_activities_${this.section.id}`;
        },

        items(){
            /**
             * Get array of ids in canvas (non-unique), but also include ids in path, which are
             * not in canvas. This is to make sure any items added to canvas later on should at
             * least come to this section.
             */

            return _.concat(
                this.canvas_items,
                this.path_items
                    .filter(path_item => !this.canvas_items
                        .filter( canvas_item => canvas_item.id === path_item.id ).length
                    )
            );
        },

        path_items(){
            return typeof this._$$path[ this.fragment_key ] !== 'undefined' ? this._$$path[ this.fragment_key ] : [];
        },

        canvas_items(){
            return (typeof this._$$canvas !== 'undefined' && typeof this._$$canvas[ this.fragment_key ] !== 'undefined') ? this._$$canvas[ this.fragment_key ] : [];
        },

        activities(){
            return this.elements.filter(e => e.element.type === 'activity');
        }

    },

    methods: {

        ...mapActions('repositories', {
            repo: 'getRepository',
            freeRepo: 'freeRepository',
            updateRepo: 'updateRepository',
        }),

        elementInPath(id){
            return this.path_items.filter(v => v.id === id).length;
        },

        elementInCanvas(id){
            return this.canvas_items.filter(v => v.id === id).length;
        },

        elementWidth(element){
            try{ return element.data.options.width } catch (e) {}
            return 1;
        },

        async addElement(element){

            const item = {
                id: this.utils.randomId({prefix: 'el'}),
                element
            };

            if( this.elements.length > 0 ){
                this.elements.splice( this.elements.length - 1, 0, item);
            }else{
                this.elements.push(item);
            }

            await this.changed();
        },

        removeCanvasElement( index ){
            this.elements.splice( index, 1);
            this.changed();
        },

        async changed(){
            const fragments = {};
            const elements = this.elements.filter(el => el.element.type !== 'add-new');
            fragments[ this.fragment_key ] = elements.map(item => ({id: item.id, v: item.element.id}));
            elements.push({ id: 'new', element: {id: 'new', type: 'add-new'} });
            this.elements = elements;
            await this.updateRepo({scope: this.canvasRepo.scope, fragments})
            await this.fetch();
        },

        async fetch(){
            if( !this.items.length ) return;

            const elements = await API.elements.bulk({ids: this.items.map(item => item.v)});

            const filled_elements = [];
            for (let i = 0; i < this.items.length; i++){
                const item = this.items[i];
                const found = elements.filter(e => e.id === item.v);
                if( found.length ){
                    filled_elements[i] = {
                        id: item.id,
                        element: found.shift(),
                    };
                }
            }

            filled_elements.push({ id: 'new', element: {id: 'new', type: 'add-new'} });
            this.elements = filled_elements;

            this.$emit('update', this.elements);

        },

        activityUploaded({element, uploaded}){
            // console.log('activityUploaded', {element, uploaded})
            this.$emit('update', this.elements);
        }

    },

    async mounted() {
        this.is_busy = true;
        await this.fetch();
        this.is_busy = false;
    }


}
</script>

<style lang="scss" scoped>
.canvas-combined-activities{
    position: relative;
    z-index: 2;
}
//.canvas-combined-activities{
//    .row{
//        margin-left: -0.4rem;
//        margin-right: -0.4rem;
//
//        > * {
//            padding-left: 0.4rem;
//            padding-right: 0.4rem;
//        }
//    }
//}

.head{
    background-color: rgba(white, 0.1);
    backdrop-filter: blur(3px);
    padding: 1em 1em 0.2em 1em;
    margin-bottom: 1em;
    border-radius: 0.3rem;
}

.number{
    position: absolute;
    left: 0px;
    top: -5px;
    width: 2.2rem;
    height: 2.2rem;
    font-size: 1.3rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    background: $success;
    color: white;
    font-weight: $font-weight-bold;
}

.activities{
    display: flex;
    margin-left: -0.3rem;
    margin-right: -0.3rem;
    flex-wrap: wrap;
    align-items: stretch;

    .item{
        position: relative;
        display: flex;
        padding: 0 0.3rem;
        margin-bottom: 0.6rem;
        @media (max-width: 650px) {
            flex-basis: 100%;
            min-height: 300px;
        }
    }

    .item-type-add-new{
        display: none;
    }

}

.aw-1{
    @include media-breakpoint-up(lg){
        flex: 0 0 20%;
    }
}

.aw-2{
    @include media-breakpoint-up(lg){
        flex: 0 0 40%;
    }
}

.aw-3{
    @include media-breakpoint-up(lg){
        flex: 0 0 60%;
    }
}
.aw-4{
    @include media-breakpoint-up(lg){
        flex: 0 0 80%;
    }
}
.aw-5{

}

</style>
